import { SizeGuideSection } from "../size-guide-section"

// src/components/size-guide-new/women/bibs-coveralls.tsx
const bibsCoverallsTableData = {
  headers: [
    [
      {
        content: "Women's Bibs And Coveralls",
        colSpan: 5
      }
    ],
    [
      {
        content: "Size"
      },
      {
        content: "Waist(In)"
      },
      {
        content: "Hipline(In)"
      },
      {
        content: "Inseam(In)"
      },
      {
        content: "US SIZE"
      }
    ]
  ],
  data: [
    [
      { content: "XS" },
      { content: "26-27" },
      { content: "35-36" },
      { content: "28" },
      { content: "0-2" }
    ],
    [
      { content: "S" },
      { content: "28-29" },
      { content: "37-38" },
      { content: "28.5" },
      { content: "4-6" }
    ],
    [
      { content: "M" },
      { content: "30-31" },
      { content: "39-40" },
      { content: "29" },
      { content: "8-10" }
    ],
    [
      { content: "L" },
      { content: "32-34" },
      { content: "41-43" },
      { content: "30" },
      { content: "12-14" }
    ],
    [
      { content: "XL" },
      { content: "36-38" },
      { content: "44-46" },
      { content: "30.5" },
      { content: "16-18" }
    ],
    [
      { content: "XXL" },
      { content: "40" },
      { content: "48" },
      { content: "31" },
      { content: "20" }
    ]
  ]
}

export const WomenBibsCoveralls = ({
  className
}: {
  className?: string
}) => {
  return <SizeGuideSection 
    title="Bibs And Coveralls"
    tableData={bibsCoverallsTableData}
    className={className}
  />
}